<!-- src/views/ControlView.vue -->
<template>
  <v-container fluid class="fill-height d-flex align-center justify-center">
    <v-row class="d-flex flex-column align-center">
      <!-- Botón Dar de alta contenedor -->
      <v-btn
        class="my-3 button-responsive"
        color="primary"
        large
        @click="goToPanelDisp"
      >
        Dar de alta contenedor
      </v-btn>

      <!-- Botón Control de activo -->
      <v-btn
        class="my-3 button-responsive"
        color="primary"
        large
        @click="goToHome"
      >
        Control de activo
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { useRouter } from "vue-router";

export default {
  name: "ControlView",
  setup() {
    const router = useRouter();

    // Función para ir a HomeView
    const goToHome = () => {
      router.push({ name: "Home" });
    };

    // Función para ir a Panel de dispositivos
    const goToPanelDisp = () => {
      router.push({ name: "PanelDispositivos" });
    };

    return {
      goToPanelDisp,
      goToHome,
    };
  },
};
</script>

<style scoped>
.v-btn {
  font-size: 1.5rem;
  width: 500px;
  height: 80px;
}

@media (max-width: 600px) {
  .button-responsive {
    width: 100%;
    font-size: 1.2rem;
    height: 60px;
  }
}
</style>
